export const PRO_TRADE_CREDIT_PORTAL_LLC_URL =
  'https://pilotapay.bectran.com/apaymgt/APayLogin?zid=8JDQu4871smBA2920kKyKg';
export const PRO_TRADE_CREDIT_PORTAL_PROD_URL =
  'https://apay.bectran.com/apaymgt/APayLogin?zid=lwfrt2665D6LZT3530uKeap';
